import axiosInstance from "./AxiosInstance";

/**
 * Get call logs for a lead
 * @param {string|number} leadId - The lead ID
 * @returns {Promise} API response with call logs list
 */
export function getCallLogs(leadId) {
  return axiosInstance.post("/lead/getCallLogs", {
    lead_id: leadId,
  });
}

/**
 * Add a new call log
 * @param {Object} callLogData - Call log data
 * @param {string|number} callLogData.lead_id - The lead ID
 * @param {string} callLogData.call_note - Call note content
 * @param {string} callLogData.lead_type - Lead type
 * @param {string} callLogData.call_type - Call type
 * @param {string} [callLogData.followup_reason] - Follow-up reason (optional)
 * @param {string} [callLogData.next_action] - Next action (optional)
 * @param {string} [callLogData.next_followup_date] - Next follow-up date (optional)
 * @returns {Promise} API response from add call log
 */
export function addCallLog(callLogData) {
  return axiosInstance.post("/lead/addCallLog", callLogData);
}

/**
 * Update an existing call log
 * @param {Object} callLogData - Call log data
 * @param {string|number} callLogData.call_log_id - The call log ID
 * @param {string|number} callLogData.lead_id - The lead ID
 * @param {string} callLogData.call_note - Call note content
 * @param {string} callLogData.lead_type - Lead type
 * @param {string} callLogData.call_type - Call type
 * @param {string} [callLogData.followup_reason] - Follow-up reason (optional)
 * @param {string} [callLogData.next_action] - Next action (optional)
 * @param {string} [callLogData.next_followup_date] - Next follow-up date (optional)
 * @returns {Promise} API response from update call log
 */
export function updateCallLog(callLogData) {
  return axiosInstance.post("/lead/updateCallLog", callLogData);
}

/**
 * Delete a call log
 * @param {string|number} callLogId - The call log ID
 * @returns {Promise} API response from delete call log
 */
export function deleteCallLog(callLogId) {
  return axiosInstance.post("/lead/deleteCallLog", {
    call_log_id: callLogId,
  });
}

/**
 * Format call logs response data
 * @param {Array|Object} responseData - The response data from API
 * @returns {Array} Formatted array of call logs
 */
export function formatCallLogs(responseData) {
  if (!responseData) return [];

  // If response is already an array
  if (Array.isArray(responseData)) {
    return responseData;
  }

  // If response is an object with a data property
  if (typeof responseData === "object" && Array.isArray(responseData.data)) {
    return responseData.data;
  }

  // If it's a single object, wrap it in an array
  if (typeof responseData === "object") {
    return [responseData];
  }

  return [];
}
